export type LanguageLabelModel = {
  [key: string]: string;
};
export const LanguageLabel: LanguageLabelModel = {
  ru: 'Русский',
  uk: 'Українська',
};
